import React from 'react'
import { useEffect, useRef, useState } from "react";
import JoditEditor from "jodit-react";
import Button from "react-bootstrap/Button";

export const ViewSop = ({value, handleEditSop,setValue, handleClose}) => {
    const editor = useRef(null); 
  const config = {
    readonly: false, // Allows editing
    toolbar: true, // Show toolbar
    buttons: [
      
      
      "bold",
      "italic",
      "underline",
      "strikethrough",
      "|",
      "ul",
      "ol",
      "|",
      "font",
      "fontsize",
      "paragraph",
      "lineHeight",
      "brush",
      "|",
      "align",
      "indent",
      "outdent",
      "|",
      "link",
      "table",
      "|",
      "undo",
      "redo",
    ], // Correct prop for toolbar buttons
  };
//   const handleEditSop = async () => {
//     try {
//       props.application.setLoading(true);
//       const data = { sop_value: value, sop_id: session_id };
//       const res = await props.admin.editSop(data);
//       if (res.success) {
//         toast.success("Sop successfully updated!", {
//           position: toast.POSITION.TOP_CENTER,
//         });
//         navigate(Routes.SESSION);
//       } else {
//         toast.error(res.message, { position: toast.POSITION.TOP_CENTER });
//       }
//       props.application.setLoading(false);
//     } catch (error) {
//       toast.error("Something went wrong!", {
//         position: toast.POSITION.TOP_CENTER,
//       });
//       props.application.setLoading(false);
//     }
//   };

  return (
    <section className="section dashboard">
    <div className="row">
      <div className="col-12">
        <div className="card recent-sales overflow-auto">
          <div className="card-body p-3">
            <div className="data-se">
              <JoditEditor
                ref={editor}
                value={value}
                config={config}
                onBlur={(newContent) => setValue(newContent)} // Update state on editor blur
                // onChange={(newContent) => setValue(newContent)} // Update state on content change
              />
              <Button variant="secondary" onClick={handleEditSop}>
                Update Sop
              </Button>
              {/*<Button variant="secondary" onClick={handleClose}>
                Back
              </Button>*/}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  )
}
